module.exports = __webpack_public_path__ + "media/images/icons/title_arrow-3c55ba9f3d376ce0571f8fdb22854a79.svg";